/** AUTO GENERATED FROM "node ./src/utils/convert-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg width="82.31" height="67.16" viewBox="0 0 82.31 67.16" fill="currentColor" className={classNames('nmx-icon', className)} ref={svgRef} {...otherProps}>
        <path d="M62.08,44A14.13,14.13,0,1,0,76.21,58.13,14.13,14.13,0,0,0,62.08,44Zm0,2.5A11.63,11.63,0,1,1,50.45,58.13,11.63,11.63,0,0,1,62.08,46.5Z" transform="translate(-36 -44)" fill="#0e497b"/><path d="M68,80.56a1.25,1.25,0,0,1,.13,2.49H49.45a11,11,0,0,0-11,10.66v2.1A1.25,1.25,0,0,1,36,96V94A13.45,13.45,0,0,1,49.14,80.56H68Z" transform="translate(-36 -44)" fill="#0e497b"/><path d="M96,66.56a22.3,22.3,0,1,0,22.3,22.3A22.29,22.29,0,0,0,96,66.56Zm0,2.5a19.8,19.8,0,1,1-19.8,19.8A19.8,19.8,0,0,1,96,69.06Z" transform="translate(-36 -44)" fill="#0e497b"/><path d="M88.11,80.94a1.23,1.23,0,0,1,1.66-.09l.1.09,13.95,13.94a1.25,1.25,0,0,1-1.67,1.86l-.1-.09L88.11,82.71A1.25,1.25,0,0,1,88.11,80.94Z" transform="translate(-36 -44)" fill="#ffb81c"/><path d="M102.05,80.94a1.25,1.25,0,0,1,1.86,1.66l-.09.1-13.95,14a1.25,1.25,0,0,1-1.77,0A1.27,1.27,0,0,1,88,95l.09-.1Z" transform="translate(-36 -44)" fill="#ffb81c"/>
      </svg>

    );
  }
}

Icon.displayName = 'PersonWithXCircleIcon';

export default Icon;
